<div class="container-fluid">
	<div class="row">
		<div class="col">
			<h4 class="text-center mt-5">{{ "logout.uscita_dal_sistema_in_corso" | translate }}</h4>
		</div>
	</div>
</div>